import Vue from 'vue'
import router from '../../router/index'

const state = {
  item: {},
  copyItem: {},
  itemId: '',
  url: '',
  isLoaded: false,
  isError: false,
  textContent: [],
  audio_files: [],
  errors: {},
  fileExtensions: {},
  savingInterval: '',
  savedFields: {},
  editorInstance: ''
}

const mutations = {
  setItem (state, item) {
    state.item = item
  },
  setAudioFiles (state, value) {
    state.audio_files = value
  },
  setCopyItem (state, item) {
    state.copyItem = item
  },
  setItemId (state, parentId) {
    state.itemId = parentId
  },
  setSavingInterval (state, value) {
    state.savingInterval = value
  },
  setSavedFields (state, value) {
    state.savedFields = value
  },
  setEditorInstance (state, value) {
    state.editorInstance = value
  },
  setUrl (state, url) {
    state.url = url
  },
  setTextContent (state, textContent) {
    state.textContent = textContent
  },
  setItemField (state, data) {
    state.item[data.fieldName] = data.value
  },
  deleteItemField (state, name) {
    let splitName = name.split('_')[0]
    delete state.item[name]
    for (let key in state.errors) {
      if (key.split('_')[0] === splitName) delete state.errors[key]
    }
    for (let key in state.item) {
      if (key.split('_')[0] === splitName) delete state.item[key]
    }
    for (let key in state.fileExtensions) {
      if (key.split('_')[0] === splitName) delete state.fileExtensions[key]
    }
    delete state.fileExtensions[name]
  },
  setErrors (state, errors) {
    state.errors = errors
  },
  setError (state, data) {
    state.errors[data.fieldId].hasError = data.flag
  },
  setIsError (state, flag) {
    state.isError = flag
  },
  setIsLoaded (state, isLoaded) {
    state.isLoaded = isLoaded
  },
  setFileExtensions (state, fileExtensions) {
    state.fileExtensions = fileExtensions
  },
  setFileExtension (state, data) {
    state.fileExtensions[data.name] = data.value
  },
  checkFile (state, data) {
    if (state.fileExtensions[data.name].indexOf(data.fileName.toLowerCase().split('.').pop()) === -1) {
      state.errors[data.name].hasError = true
      state.isError = true
    } else {
      state.errors[data.name].hasError = false
      state.isError = false
    }
  },
  checkFieldFilling (state) {
    let hasError = false
    for (let key in state.item) {
      if (state.item.hasOwnProperty(key) && state.errors.hasOwnProperty(key)) {
        if (!state.item[key] && !state.errors[key].isNullable) {
          state.errors[key].hasError = true
          hasError = true
        } else {
          state.errors[key].hasError = false
        }
      }
    }
    state.isError = hasError
  },

  resetModule (state) {
    state.item = {}
    state.copyItem = {}
    state.itemId = ''
    state.isLoaded = false
    state.isError = false
    state.textContent = []
    state.errors = []
  }
}

const actions = {
  reset ({state, commit}) {
    let path = window.location.pathname
    if (localStorage.hasOwnProperty(path)) localStorage.removeItem(path)
    console.log('reset')
    router.go()
  },
  init ({commit, dispatch, rootGetters, rootState}, data) {
    commit('setTextContent', data.textContent)
    commit('setUrl', data.apiUrl)
    commit('setItemId', data.itemId)
    commit('setErrors', data.errors)
    return new Promise((resolve) => {
      Vue.prototype.$http.get(
        `${state.url}/${state.itemId}`
      ).then(response => {
        let data = response.data.data
        if (data.object) {
          data.object = JSON.parse(data.object)
        }
        if (state.url === rootState.apiUrls.feedback && !data.is_viewed) {
          dispatch('readReview', data.id)
        }
        commit('setCopyItem', JSON.parse(JSON.stringify(data)))
        let path = window.location.pathname
        if (localStorage.hasOwnProperty(path)) {
          if (confirm('После последнего редактирования данного контента есть несохраненные данные. Хотели бы Вы востановить их?')) {
            commit('setSavedFields', JSON.parse(localStorage.getItem(path)))
            for (let key in state.savedFields) {
              if (state.savedFields.hasOwnProperty(key)) {
                if (data.object !== null && data.object.hasOwnProperty(key)) {
                  data.object[key] = state.savedFields[key]
                } else if (key === 'titleFirst' || key === 'titleSecond') {
                  let object = {
                    'title.1': state.savedFields.hasOwnProperty('titleFirst') ? state.savedFields.titleFirst : data.object['title.1'],
                    'title.2': state.savedFields.hasOwnProperty('titleSecond') ? state.savedFields.titleSecond : data.object['title.2']
                  }
                  data.object = object
                } else {
                  data[key] = state.savedFields[key]
                }
              }
            }
          } else {
            localStorage.removeItem(path)
          }
        }
        commit('setIsLoaded', true)
        commit('setItem', data)
        dispatch('savingData')
        console.log('dis')
        resolve(data)
      }, error => {
        dispatch('notification/errorAxios', error.response.status, {root: true})
      })
    })
  },
  edit ({state, commit, dispatch, rootGetters, rootState}, params) {
    return new Promise(async resolve => {
      commit('checkFieldFilling')
      if (params.hasOwnProperty('url')) {
        await dispatch('checkUnique', {
          fieldValue: params.url,
          fieldName: 'url',
          message: 'Ссылка должна быть уникальной'
        })
      }
      if (params.hasOwnProperty('title')) {
        await dispatch('checkUnique', {
          fieldValue: params.title,
          fieldName: 'title',
          message: 'Название должно быть уникальным'
        })
      }
      if (!state.isError) {
        Vue.prototype.$http.put(
          `${state.url}/${state.itemId}`,
          params
        ).then(async (res) => {
          commit('setCopyItem', JSON.parse(JSON.stringify(state.item)))
          let lastNews = await Vue.prototype.$http.get(`api/contents?search=parent_id:${rootState.parentId.news};content_id:${res.data.data.id}&searchJoin=and`)
          if (lastNews.data.data.length) {
            resolve({lastNews: lastNews.data.data[0], article: res.data.data})
          }
          let path = window.location.pathname
          if (localStorage.hasOwnProperty(path)) localStorage.removeItem(path)
          let section = path.split('/')[1]
          let newPath = section === 'library' ? `/${section}/${path.split('/')[2]}` : `/${section}`
          router.push(newPath)
          dispatch('notification/triggerSelfDismissingNotification', {
            message: state.textContent.greeting,
            isError: false
          }, {root: true})
        }).catch(error => {
          dispatch('notification/errorAxios', error.response.status, {root: true})
        })
      }
    })

  },
  savingData ({commit, state}) {
    let path = window.location.pathname
    let data;
    commit('setSavingInterval', setInterval(() => {
      data = {}
      for (let key in state.item) {
        if (state.item.hasOwnProperty(key)) {
          if (key === 'text' && state.editorInstance !== '') {
            let editorText = state.editorInstance.getData()
            editorText = editorText.substring(0, editorText.length - 1)
            console.log(editorText.length)
            if ((state.copyItem[key] === null && editorText !== '') || (state.copyItem[key] !== null && editorText !== state.copyItem[key])) {
              data.text = state.editorInstance.getData()
            }
          } else if (key === 'created_at') {
            if (state.item[key].split(' ').length !== 2) {
              if (state.item[key] + ' 00:00:00' !== state.copyItem[key]) {
                data[key] = state.item[key]
              }
            }
          } else if (key === 'titleFirst' || key === 'titleSecond') {
            let keyName = key === 'titleFirst' ? 'title.1' : 'title.2'
            if (state.item[key] !== state.copyItem.object[keyName]) data[key] = state.item[key]
          } else if (key === 'object' || key === 'audio_files') {
          } else {
            if (state.item[key] !== '' && state.item[key] !== state.copyItem[key]) {
              if ((path.includes('albums') && key !== 'title') || (path.includes('audio') && (key.includes('name_') || key.includes('file_')))) {
              } else {
                if (state.item.object !== null && state.item.object.hasOwnProperty(key)) {
                  if (state.copyItem.object[key] !== state.item[key]) data[key] = state.item[key]
                } else {
                  data[key] = state.item[key]
                }
              }
            }

          }
        }
      }
      if (Object.keys(data).length) {
        localStorage.setItem(path, JSON.stringify(data))
        console.log('Saved Data')
      } else {
        localStorage.removeItem(path)
      }
    }, 10000))
  },
  async updateNews ({rootState, commit, state, dispatch}, data) {
    let object = {section_id: data.section_id}
    if (data.url.categoryId) {
      let categoryData = await Vue.prototype.$http.get(
        `${rootState.apiUrls.content}/${data.url.categoryId}`
      )
      object.category_url = categoryData.data.data.url
    } else {
      object.category_url = null
    }
    if (data.hasOwnProperty('date_end')) {
      object.date_end = data.date_end
      object.bool = data.bool
    }
    Vue.prototype.$http.put(
      `${rootState.apiUrls.content}/${data.newsId}`,
      {
        parent_id: rootState.parentId.news,
        content_id: data.id,
        title: data.title,
        url: data.url.articleUrl,
        img: data.img,
        subtext: data.subtext,
        is_active: data.is_active,
        object: JSON.stringify(object)
      }
    ).then(res => {
      console.log(res)
    })
  },
  checkUnique ({commit, state, dispatch}, data) {
    return new Promise(resolve => {
      if (data.fieldValue !== state.copyItem[data.fieldName]) {
        Vue.prototype.$http.get(`${state.url}?searchFields=${data.fieldName}&search=${data.fieldValue}`).then((response) => {
          if (response.data.data.length) {
            commit('setError', {fieldId: data.fieldName, flag: true})
            dispatch('notification/triggerSelfDismissingNotification', {
              message: data.message,
              isError: true
            }, {root: true})
            commit('setIsError', true)
            resolve()
          } else {
            resolve()
          }
        })
      } else {
        resolve()
      }

    })

  },
  readReview ({dispatch}, id) {
    Vue.prototype.$http.put(`/api/feedback/${id}`, {is_viewed: true})
      .then(() => {
        dispatch('getNewReviews', null, {root: true})
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/editPage.js